import React from 'react';


const ProgressRing = ({ 
  percentage = 0, 
  title = "Overall Progress", 
  subtitle = "",
  size = 'lg',
  showPercentage = true,
  className = ""
}) => {
  const sizeConfig = {
    sm: { ring: 80, stroke: 6, text: 'text-lg', subtitle: 'text-xs' },
    md: { ring: 120, stroke: 8, text: 'text-2xl', subtitle: 'text-sm' },
    lg: { ring: 160, stroke: 10, text: 'text-3xl', subtitle: 'text-base' }
  };

  const config = sizeConfig?.[size];
  const radius = (config?.ring - config?.stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDasharray = circumference;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  return (
    <div className={`flex flex-col items-center space-y-4 ${className}`}>
      <div className="relative">
        <svg 
          width={config?.ring} 
          height={config?.ring} 
          className="transform -rotate-90"
          viewBox={`0 0 ${config?.ring} ${config?.ring}`}
        >
          {/* Background circle */}
          <circle
            cx={config?.ring / 2}
            cy={config?.ring / 2}
            r={radius}
            stroke="currentColor"
            strokeWidth={config?.stroke}
            fill="transparent"
            className="text-muted"
          />
          {/* Progress circle */}
          <circle
            cx={config?.ring / 2}
            cy={config?.ring / 2}
            r={radius}
            stroke="currentColor"
            strokeWidth={config?.stroke}
            fill="transparent"
            strokeDasharray={strokeDasharray}
            strokeDashoffset={strokeDashoffset}
            className="text-primary transition-all duration-500 ease-in-out"
            strokeLinecap="round"
          />
        </svg>
        
        {/* Center content */}
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          {showPercentage && (
            <span className={`font-bold font-mono text-foreground ${config?.text}`}>
              {Math.round(percentage)}%
            </span>
          )}
          <div className="text-center">
            <div className="text-sm font-medium text-foreground">{title}</div>
            {subtitle && (
              <div className={`text-muted-foreground ${config?.subtitle}`}>
                {subtitle}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressRing;